import { useEffect, useState, type ReactNode } from 'react';
import { Warehouse } from 'lucide-react';
import { signIn } from '../lib/auth';

// Uygulama Microsoft girişinden sonra açılır (#27).
export function AuthGate({ children }: { children: ReactNode }) {
  const [authed, setAuthed] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    signIn().then(() => setAuthed(true), (e: { errorCode?: string }) => setError(e.errorCode ?? 'unknown'));
  }, []);

  if (authed) return <>{children}</>;

  return (
    <div className="h-screen bg-surface flex items-center justify-center">
      <div className="bg-white border border-border rounded w-[360px] p-8 space-y-3 text-center">
        <div className="flex items-center justify-center gap-2">
          <Warehouse size={24} className="text-accent" />
          <h1 className="text-lg font-semibold text-primary">ESL Depo</h1>
        </div>
        {error ? (
          <>
            <p className="text-status-red text-sm">Giriş yapılamadı ({error}).</p>
            <button
              onClick={() => window.location.reload()}
              className="w-full py-2 bg-accent hover:bg-accent/90 text-white rounded-sm text-sm font-medium transition-colors"
            >
              Tekrar dene
            </button>
          </>
        ) : (
          <p className="text-secondary text-sm">Microsoft hesabıyla giriş yapılıyor…</p>
        )}
      </div>
    </div>
  );
}
